import { Injectable } from "@angular/core";
import { EditDialogService } from '../../../core/components/editDialog/editDialogService';
import { CommandInput, CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { CommandService, Flow, HasCommands } from '../../../core/services/command/command.service';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { FinishTourDialogComponent } from "src/app/shared-module/components/finish-tour-dialog/finish-tour-dialog.component";
import { TourInput } from "../entities/tour";

@Injectable({
    providedIn: 'root'
  })
export class TourFinishCommandCustomFlow implements Flow {

  dialogRef: DynamicDialogRef | undefined;

  constructor(
    private dialogService: EditDialogService
  ) { }

  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void) {

      let tourId = commandInput?.parameters?.commandProviderId;

      this.dialogRef = this.dialogService.open(FinishTourDialogComponent, {
        width: "500px",
        header: commandTemplate?.flow?.settings?.customFlowSettings?.title,
        data: {
          commandTemplate: commandTemplate,
        }
      });
      this.dialogRef.onClose.subscribe((result) => {
        if(result){
          let tourInput = new TourInput();
          tourInput.id = tourId;
          if(result.actualArrivalDateTime){
            tourInput.actualArrivalDateTime = result.actualArrivalDateTime;
          }
          
          console.log("TourInput", tourInput);
          commandInput.addParameter("tourInput", tourInput);
          commandService.sendCommand(commandInput, () => {
            completionCallback();
          })
        }
      });

    
  }
  
}